<script setup>
import {useRoute} from "vue-router";
import {computed, onMounted, ref, watch} from "vue";
import store from "@/store";
import {couponConf} from "@/utils/config";
import CopyRightComponents from "@/components/system/CopyRightComponents.vue";
import axiosApi, {$_ajax} from "@/utils/axiosApi";
import {ElMessage} from "element-plus";
import LoginComponents from "@/components/login/LoginComponents.vue";
import router from "@/router";
import JdProduct from "@/components/zxjd/jdProduct.vue";
import SqProduct from "@/components/sqwl/sqProduct.vue";
import {Base64} from "js-base64";
import XmLogin from "@/components/login/xmLogin.vue";
import MeLandProduct from "@/components/meland/meLandProduct.vue";
import wx from "weixin-js-sdk";
import HbwlProductComponent from "@/components/hbwl/HbwlProductComponent.vue";
import HklProductLstComponent from "@/components/hkl/HklProductLstComponent.vue";
import LuoSqProductComponent from "@/components/lsq/LuoSqProductComponent.vue";
import {gotoUrl} from "@/utils/func";
import TmIndexComponent from "@/components/tm-mark/TmIndexComponent.vue";
import PyfProduct from "@/components/pyf/PyfProduct.vue";
import HllProductComponent from "@/components/haolilai/HllProductComponent.vue";
import BeiguoProductComponent from "@/components/beiguo/BeiguoProductComponent.vue";
import AtlIndexComponent from "@/components/atl/AtlIndexComponent.vue";
import HiBakeIndex from "@/components/hibake/HiBakeIndex.vue";
import WjgIndexComponent from "@/components/waijiaoguan/WjgIndexComponent.vue";
import YzIndex from "@/components/yuanzu/YzIndex.vue";

const route = useRoute()
const cid = ref(0)
const type = computed(() => {
  let coupon = store.state.coupon
  if (!coupon) return {}
  let coup = couponConf[coupon] || {}
  document.title = coup.title
  return coup
})
const couponLst = ref([])
const showLogin = ref(false)
const mobile = ref('')
const account = computed(() => {
  let act = store.state.account
  if (Object.keys(act).length < 1) return {}
  // eslint-disable-next-line vue/no-side-effects-in-computed-properties
  mobile.value = act.phoneNumber
  return act
})
const payFrom = computed(()=>store.state.orderFrom)

onMounted(() => {
  store.commit("getOrderFrom")
  if (route.query.type) store.commit("setCoupon", route.query.type)
  if (route.query.from) store.commit("setOrderFrom", route.query.from)
  else store.commit("getCoupon")
  //单点登录
  if (route.query.customerId) {
    $_ajax.get(`${process.env.VUE_APP_ONE_WAY}scal/check`, {params: route.query}).then(({data}) => {
      if (data.data) {
        data.data.phoneNumber = Base64.decode(data.data.phoneNumber)
        window.sessionStorage.setItem("diff_account", JSON.stringify(data.data));
        store.dispatch("setAccounts", data.data)
      } else {
        store.commit("removeAccount")
      }
    }).catch(() => store.commit("removeAccount"))
  }
 detail()
  store.dispatch("getAccounts")
  wx.miniProgram.postMessage({
    data: {
      type: 'share',
      data: {
        title: type.value.title,
        desc: '',
        path: `${location.protocol}//${location.host}/?type=${store.state.coupon}`, // 分享路径，可以包含查询参数
        imageUrl: `${location.protocol}//${location.host}/${type.value.banner}` // 分享图标URL
      }
    }
  });
  // console.log(wx.showShareMenu())
})
watch(type,()=>{
  detail()
})
const detail = ()=>{
  let axiosConfig = {
    encode: "site",
    method: "coupon/cat_coupon",
    body: {
      code: type.value?.type
    }
  }
  if(type.value?.product_type && type.value?.product_type === 'third'){
    axiosConfig.method = "life/goodsLst";
    axiosConfig.encode = "coupon"
    axiosConfig.body = {
      type: type.value?.type,
      child: type.value?.child
    }
  }
  new axiosApi(axiosConfig).send(res => {
    if (res.message.code !== "000") {
      return ElMessage.error(res.message.content)
    }
    couponLst.value = res.data
  })
}
const login = id => {
  cid.value = id
  showLogin.value = true
}

const reditLogin = () => {
  showLogin.value = false
  if (cid.value > 0) {
    router.push({
      name: 'detail',
      params: {
        id: cid.value
      }
    })
  }
}
</script>

<template>
  <el-scrollbar class="page-home page-pid" :style="type.style">
    <div class="banner">
      <el-image :src="type.banner"/>
    </div>
    <div class="account-items">
      <div class="account-toolbar">
        <div class="logo">
          <el-image :src="type.logo" v-if="type.logo && payFrom !== 'xm_air'" style="width: 100px"/>
          <div v-if="type?.type !== 'waijiaoguan'">
            <el-button round class="recharge_score_btn" type="primary"
                       @click="gotoUrl('https://cdn-mfemas.xiamenair.com/xiahang-emas-cdn/app/Egret_App-uniapp_ffp/h5/index.html#/partner/index')"
                       v-if="type.login === 'xm_air' && payFrom === 'xm_air'">白鹭积分实时到账 点击赚取
            </el-button>
            <el-button class="recharge_score_btn" type="primary"
                      @click="gotoUrl('https://s.xiamenair.com/f44cf05')"
                      v-else-if="type.login === 'xm_air' && payFrom !== 'xm_air' && type.type === 'hbwl'" round>新会员入会，送300积分
            </el-button>
            <el-button class="recharge_score_btn" type="primary"
                       @click="gotoUrl('https://cdn-mfemas.xiamenair.com/xiahang-emas-cdn/app/Egret_App-ffp2/h5/index.html#/usersystem/registry/?remark=1618_03%3Fu1ccxW0EjG4fWPOchVuaSQ%3D%3D_12&spm=27a8e09')"
                       v-else-if="type.login === 'xm_air' && payFrom !== 'xm_air' && type.type === 'beiguo'" round style="font-size: .8rem">新会员入会送300积分，马上入会
            </el-button>
          </div>
        </div>
        <div class="account-btn-group">
          <div class="account-btn" @click="router.push({name:'order'})">
            <i class="ticket-font ticket-order-info"></i>
            兑换记录
          </div>
          <div class="account-btn" v-if="Object.keys(account).length" @click="store.commit('removeAccount')">
            <i class="ticket-font ticket-logout"></i>
            退出登录
          </div>
        </div>
      </div>
      <div class="account-input">
        <el-input placeholder="请输入川航金熊猫会员手机号" class="account-input-its" v-model="mobile" size="large"
                  :disabled="Object.keys(account).length" v-if="type.login === 'scal'">
          <template #prefix>
            <el-icon size="25" color="#E52421">
              <Search/>
            </el-icon>
          </template>
          <template #suffix>
            <el-button type="danger" v-if="Object.keys(account).length < 1" @click="showLogin=true">查询可用里程
            </el-button>
            <span v-else>
              <b>可用里程：</b><el-button link type="danger" disabled>{{ account.balance_miles }}</el-button>
            </span>
          </template>
        </el-input>
        <el-input placeholder="请输入白鹭会员手机号" class="account-input-its" v-model="mobile" size="large"
                  :disabled="Object.keys(account).length" v-if="type.login === 'xm_air'">
          <template #prefix>
            <el-icon size="25" color="#477FEB">
              <Search/>
            </el-icon>
          </template>
          <template #suffix>
            <el-button link type="primary" v-if="Object.keys(account).length < 1" @click="showLogin=true">查询可用积分
            </el-button>
            <span v-else>
              <b>可用积分：</b><el-text type="primary" disabled>{{ account.balance_miles }}</el-text>
            </span>
          </template>
        </el-input>
      </div>
    </div>
    <jd-product :coupon-lst="couponLst" v-if="type.type==='jd-scal'" :account="account" @login="login"/>
    <sq-product :coupon-lst="couponLst" v-if="type.type==='sqwl'" :account="account" @login="login"/>
    <hbwl-product-component :coupon-lst="couponLst" v-if="type.type==='hbwl'" :account="account" @login="login"/>
    <me-land-product :coupon-lst="couponLst" v-if="type.type==='meland' || type.type==='meland-scal'" :account="account"
                     @login="login"
                     :type="type"/>
    <hkl-product-lst-component :coupon-lst="couponLst" v-if="type.type==='hkl'" :type="type" :account="account"
                               @login="login"/>
    <luo-sq-product-component v-if="type.type==='lsq'" :coupon-lst="couponLst" :account="account" @login="login"
                              :type="type"/>
    <pyf-product v-if="type.type==='pyf'" :coupon-lst="couponLst" :account="account" @login="login" :type="type"/>
    <tm-index-component v-if="type.type === 'jlx' && type.child==='tm'" :coupon-lst="couponLst"/>
    <hll-product-component v-if="type.type === 'haoll'" :coupon-lst="couponLst" :account="account" @login="login" :type="type"/>
    <beiguo-product-component v-if="type.type === 'beiguo'" :coupon-lst="couponLst" :account="account" @login="login" :type="type"/>
    <atl-index-component v-if="type.type === 'atl'" :coupon-lst="couponLst" :account="account" @login="login" :type="type"/>
    <hi-bake-index v-if="type.type === 'hibake'" :coupon-lst="couponLst" :account="account" @login="login" :type="type"/>
    <wjg-index-component v-if="type.type === 'waijiaoguan'" :coupon-lst="couponLst" :account="account" @login="login" :type="type"/>
    <yz-index v-if="type.type === 'lanting-yuanzu'" :coupon-lst="couponLst" :account="account" @login="login" :type="type"/>
    <copy-right-components/>
  </el-scrollbar>
  <login-components :show-login="showLogin" :account="mobile" v-if="showLogin && type.login === 'scal'"
                    @login="reditLogin"/>
  <xm-login :show-login="showLogin" :account="mobile" v-if="showLogin && type.login === 'xm_air'" @login="reditLogin"/>
</template>

<style scoped lang="less">
.page-home {
  height: 100vh;
  background-color: var(--theme-color);

  .banner {
    padding: 15px;
    .el-image{
      width: 100%;
    }
  }

  .account-items {
    .account-toolbar {
      display: flex;
      justify-content: space-between;
      padding-left: 15px;
      margin-bottom: 15px;

      .logo {
        width: 190px;
      }

      .account-btn {
        padding-left: 20px;
        padding-right: 25px;
        background: #ffffff;
        color: var(--theme-text-color);
        line-height: 35px;
        border-radius: 45px 0 0 45px;
        font-weight: 600;
        white-space: nowrap;

        & + .account-btn {
          margin-top: 8px;
        }
      }
    }

    .account-input {
      padding: 0 15px;
    }
  }
}
</style>
